export default {
  AppConfig: 'AppConfig',
  token: 'user-token',
};
